// Zustand auth store — manages admin authentication state
import { create } from "zustand";
import { persist } from "zustand/middleware";
import api, { formatApiError } from "../lib/api";

export const useAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            accessToken: null,
            refreshToken: null,
            loading: false,
            error: null,

            login: async (username, password) => {
                set({ loading: true, error: null });
                try {
                    const { data } = await api.post("/auth/login", {
                        username,
                        password,
                    });
                    set({
                        user: data.user,
                        accessToken: data.access_token,
                        refreshToken: data.refresh_token,
                        loading: false,
                        error: null,
                    });
                    api.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
                    return data.user;
                } catch (e) {
                    const msg = formatApiError(e);
                    set({ loading: false, error: msg });
                    throw new Error(msg);
                }
            },

            logout: async () => {
                try {
                    await api.post("/auth/logout");
                } catch (_) {
                    // ignore
                }
                set({ user: null, accessToken: null, refreshToken: null });
                delete api.defaults.headers.common.Authorization;
            },

            checkAuth: async () => {
                try {
                    if (get().accessToken) {
                        api.defaults.headers.common.Authorization = `Bearer ${get().accessToken}`;
                    }
                    const { data } = await api.get("/auth/me");
                    set({ user: data.user });
                    return data.user;
                } catch (_) {
                    set({ user: null, accessToken: null, refreshToken: null });
                    delete api.defaults.headers.common.Authorization;
                    return null;
                }
            },

            setError: (error) => set({ error }),
        }),
        {
            name: "otelpro-auth",
            partialize: (s) => ({
                accessToken: s.accessToken,
                refreshToken: s.refreshToken,
                user: s.user,
            }),
        },
    ),
);
